import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ZorroInterceptorHttpParams } from './zorro-interceptor-http-params';
import { SpinnerStoreService } from '../services/spinner-store-service/spinner-store.service';

@Injectable({ providedIn: 'root' })
export class ZorroSpinnerInterceptor implements HttpInterceptor {

    constructor(
        private spinnerService: SpinnerStoreService) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        const spinnerMessage = req.params instanceof ZorroInterceptorHttpParams ? req.params.spinnerConfig.spinnerMessage : null;

        if (spinnerMessage) {
            this.spinnerService.showSpinner(spinnerMessage, spinnerMessage);
        }

        return next.handle(req)
            .pipe(
                finalize(() => this.spinnerService.hideSpinner(spinnerMessage))
            );
    }
}
